import { Pipe, PipeTransform } from '@angular/core';
import { ValidationPatterns } from '@zero/shared/util-models';

@Pipe({
  name: 'password',
  standalone: true,
})
export class PasswordPipe implements PipeTransform {
  readonly #passwordPattern: RegExp = ValidationPatterns.passwordPattern;

  public transform(value: string): boolean {
    return !value ? null : !!this.#passwordPattern.exec(value);
  }
}
